import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RideMonitoringState } from './ride-monitoring.reducer';

export const rideMonitoringState = createFeatureSelector<RideMonitoringState>('rideMonitoring');

export const getTransitPrograms = createSelector(rideMonitoringState, state => state.transitPrograms);

export const getTransitProgramIds = createSelector(rideMonitoringState, state =>
  state.transitPrograms.map(transitProgram => transitProgram.id)
);

export const getOperationsAlertTypes = createSelector(rideMonitoringState, state => state.operationsAlertTypes);

export const getOperationsAlertTypeIds = createSelector(rideMonitoringState, state =>
  state.operationsAlertTypes.map(operationsAlertTypeIds => operationsAlertTypeIds.id)
);

export const getIsInitialDataLoaded = createSelector(
  rideMonitoringState,
  state => state.operationsAlertTypes.length > 0 && state.transitPrograms.length > 0
);

export const selectedRideStatusNames = createSelector(rideMonitoringState, state => state?.selectedRideStatusNames);

export const selectedTransitProgramIds = createSelector(rideMonitoringState, state => state?.selectedTransitProgramIds);

export const selectedOperationsAlertTypeIds = createSelector(rideMonitoringState, state => state?.selectedOperationsAlertTypeIds);

export const hasNoSelectedFilters = createSelector(rideMonitoringState, state => {
  return (
    state.selectedRideStatusNames.length === 0 &&
    state.selectedTransitProgramIds.length === 0 &&
    state.selectedOperationsAlertTypeIds.length === 0
  );
});

export const isStateEmpty = createSelector(rideMonitoringState, state => {
  return (
    state.selectedRideStatusNames.length === 0 &&
    state.selectedTransitProgramIds.length === 0 &&
    state.selectedTransitProgramIds.length === 0
  );
});

export const getAlerts = createSelector(rideMonitoringState, (state: RideMonitoringState) => state.alerts);

export const getSelectedAlert = createSelector(rideMonitoringState, (state: RideMonitoringState) => state.selectedAlert);

export const getSelectedReservationListItemVm = createSelector(
  rideMonitoringState,
  (state: RideMonitoringState) => state?.selectedReservationListItemVm
);

export const getDriverProfilePictureUrl = createSelector(
  rideMonitoringState,
  (state: RideMonitoringState) => state.driverProfilePictureUrl
);

export const getCustomerServiceNotes = createSelector(rideMonitoringState, (state: RideMonitoringState) => state.notes);

export const getTotalCount = createSelector(rideMonitoringState, (state: RideMonitoringState) => state.totalCount);

export const getIsAlertCountEqualToTotalCount = createSelector(
  rideMonitoringState,
  (state: RideMonitoringState) => state.alerts.length === state.totalCount
);
